export default __webpack_public_path__ + "static/media/hrv.1ca2db85.png";